import { render, staticRenderFns } from "./GlobalInformationStatus.vue.js?vue&type=template&id=634b5a7c&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GlobalInformationStatus.vue?vue&type=template&id=634b5a7c&scoped=true"
import script from "./GlobalInformationStatus.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GlobalInformationStatus.vue?vue&type=script&lang=js"
export * from "./GlobalInformationStatus.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GlobalInformationStatus.vue?vue&type=script&lang=js"
import style0 from "./GlobalInformationStatus.vue.scss?vue&type=style&index=0&id=634b5a7c&prod&lang=scss&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GlobalInformationStatus.vue?vue&type=style&index=0&id=634b5a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634b5a7c",
  null
  
)

export default component.exports